import React, { useContext, useEffect } from 'react';
import { TravelBotLogoImage } from '../../TravelBotLogoImage';
import { ChatMessage, Text, Button, Flex } from 'pcln-design-system';
import MessageFooter from '../MessageFooter/MessageFooter';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import { mapManager } from '../Maps/googleMapManager';
import { MapIcon } from '../Maps/SinglePinIcon';
import { useChatUIContext } from '../../hooks/useChatUIContext';
import { mapPinType } from '../../constants';
import { expressDealHotelId } from '../../HotelComponent/useSetHotelPinOnMapHook';
import analytics from '../../analytics/analytics';
export const TextWithInlineMetadataComponent = React.memo(props => {
  const {
    displayableInlineContents,
    metadataCollection
  } = props;
  const {
    appendNewPinToList,
    hotelOnMapList
  } = useContext(ChatbotDataContext);
  const {
    setIsMapOpened
  } = useChatUIContext();
  useEffect(() => {
    appendNewPinToList({
      listOfPins: metadataCollection
    });
  }, []);
  const handleMapButtonClick = (pinsInCurrentLine, targetPin) => {
    if ((targetPin === null || targetPin === void 0 ? void 0 : targetPin.type) === mapPinType.HOTEL && (targetPin === null || targetPin === void 0 ? void 0 : targetPin.hotelId)) {
      // Find hotel result from existing hotel result
      const hotelPin = hotelOnMapList === null || hotelOnMapList === void 0 ? void 0 : hotelOnMapList.find(p => {
        var _a;
        const hotel = p === null || p === void 0 ? void 0 : p.hotel;
        if ((hotel === null || hotel === void 0 ? void 0 : hotel.hotelType) === 'SOPQ') {
          const expressId = expressDealHotelId(hotel);
          return expressId === targetPin.hotelId;
        } else {
          return String((_a = p === null || p === void 0 ? void 0 : p.hotel) === null || _a === void 0 ? void 0 : _a.hotelId) === String(targetPin.hotelId);
        }
      });
      // If hotel result is found, open hotel detail page
      if (hotelPin && (hotelPin === null || hotelPin === void 0 ? void 0 : hotelPin.hotelDetailURL)) {
        analytics.log({
          label: 'HotelSearchResult',
          hotelId: hotelPin.hotelId,
          message: 'HOTEL_DETAIL_LINK_CLICKED',
          clickedOnPennMessage: 'Y'
        });
        window.open(hotelPin.hotelDetailURL, '_blank');
        return;
      }
    } else {
      setIsMapOpened(true);
      mapManager.addCallback(() => {
        mapManager.fitBoundsOnCurrentMap(pinsInCurrentLine).catch(() => {});
      });
    }
  };
  return React.createElement(ChatMessage, {
    ml: '',
    mb: 4,
    variation: 'initial',
    Icon: TravelBotLogoImage,
    message: displayableInlineContents.map((content, ci) => {
      if (Array.isArray(content)) {
        const allMetaInThisLine = content.filter(c => {
          if (typeof c === 'object' && (c === null || c === void 0 ? void 0 : c.metadata)) {
            return true;
          }
          return false;
        });
        const pinsInCurrentLine = allMetaInThisLine.map(m => m.metadata);
        return React.createElement(React.Fragment, {
          key: `array-content-${ci}`
        }, React.createElement(Text, {
          mb: 1
        }, content.map((c, cii) => {
          var _a;
          if (typeof c === 'string') {
            return React.createElement(React.Fragment, {
              key: `meta-content-${cii}`
            }, React.createElement(Text.span, {
              mb: 1
            }, c));
          } else if (c === null || c === void 0 ? void 0 : c.metadata) {
            return React.createElement(React.Fragment, {
              key: `meta-content-${cii}`
            }, React.createElement(Button, {
              variation: 'link',
              style: {
                transform: 'translateY(5px)'
              },
              onClick: function (event) {
                event.stopPropagation();
                event.preventDefault();
                handleMapButtonClick(pinsInCurrentLine, c === null || c === void 0 ? void 0 : c.metadata);
              }
            }, React.createElement(Flex, {
              alignItems: 'center'
            }, MapIcon({
              type: (_a = c.metadata) === null || _a === void 0 ? void 0 : _a.type,
              iconProp: {
                color: 'primary',
                size: 20
              }
            }), React.createElement(Text.span, {
              fontSize: 2,
              ml: 1,
              bold: c.metadata.type === mapPinType.HOTEL ? true : false
            }, c.metadata.name))));
          }
        })));
      } else if (content) {
        return React.createElement(React.Fragment, {
          key: `text-content-${ci}`
        }, React.createElement(Text, {
          mb: 1
        }, content));
      }
    }),
    footer: React.createElement(MessageFooter, null)
  });
});
TextWithInlineMetadataComponent.displayName = 'InlineMetadataComponent';